/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdRolesHistory200Ok
 */
export interface GetCorporationsCorporationIdRolesHistory200Ok {
    /**
     * changed_at string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdRolesHistory200Ok
     */
    changedAt: Date;
    /**
     * The character whose roles are changed
     * @type {number}
     * @memberof GetCorporationsCorporationIdRolesHistory200Ok
     */
    characterId: number;
    /**
     * ID of the character who issued this change
     * @type {number}
     * @memberof GetCorporationsCorporationIdRolesHistory200Ok
     */
    issuerId: number;
    /**
     * new_roles array
     * @type {Array<string>}
     * @memberof GetCorporationsCorporationIdRolesHistory200Ok
     */
    newRoles: Array<GetCorporationsCorporationIdRolesHistory200OkNewRolesEnum>;
    /**
     * old_roles array
     * @type {Array<string>}
     * @memberof GetCorporationsCorporationIdRolesHistory200Ok
     */
    oldRoles: Array<GetCorporationsCorporationIdRolesHistory200OkOldRolesEnum>;
    /**
     * role_type string
     * @type {string}
     * @memberof GetCorporationsCorporationIdRolesHistory200Ok
     */
    roleType: GetCorporationsCorporationIdRolesHistory200OkRoleTypeEnum;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdRolesHistory200OkNewRolesEnum = {
    AccountTake1: 'Account_Take_1',
    AccountTake2: 'Account_Take_2',
    AccountTake3: 'Account_Take_3',
    AccountTake4: 'Account_Take_4',
    AccountTake5: 'Account_Take_5',
    AccountTake6: 'Account_Take_6',
    AccountTake7: 'Account_Take_7',
    Accountant: 'Accountant',
    Auditor: 'Auditor',
    BrandManager: 'Brand_Manager',
    CommunicationsOfficer: 'Communications_Officer',
    ConfigEquipment: 'Config_Equipment',
    ConfigStarbaseEquipment: 'Config_Starbase_Equipment',
    ContainerTake1: 'Container_Take_1',
    ContainerTake2: 'Container_Take_2',
    ContainerTake3: 'Container_Take_3',
    ContainerTake4: 'Container_Take_4',
    ContainerTake5: 'Container_Take_5',
    ContainerTake6: 'Container_Take_6',
    ContainerTake7: 'Container_Take_7',
    ContractManager: 'Contract_Manager',
    DeliveriesContainerTake: 'Deliveries_Container_Take',
    DeliveriesQuery: 'Deliveries_Query',
    DeliveriesTake: 'Deliveries_Take',
    Diplomat: 'Diplomat',
    Director: 'Director',
    FactoryManager: 'Factory_Manager',
    FittingManager: 'Fitting_Manager',
    HangarQuery1: 'Hangar_Query_1',
    HangarQuery2: 'Hangar_Query_2',
    HangarQuery3: 'Hangar_Query_3',
    HangarQuery4: 'Hangar_Query_4',
    HangarQuery5: 'Hangar_Query_5',
    HangarQuery6: 'Hangar_Query_6',
    HangarQuery7: 'Hangar_Query_7',
    HangarTake1: 'Hangar_Take_1',
    HangarTake2: 'Hangar_Take_2',
    HangarTake3: 'Hangar_Take_3',
    HangarTake4: 'Hangar_Take_4',
    HangarTake5: 'Hangar_Take_5',
    HangarTake6: 'Hangar_Take_6',
    HangarTake7: 'Hangar_Take_7',
    JuniorAccountant: 'Junior_Accountant',
    PersonnelManager: 'Personnel_Manager',
    ProjectManager: 'Project_Manager',
    RentFactoryFacility: 'Rent_Factory_Facility',
    RentOffice: 'Rent_Office',
    RentResearchFacility: 'Rent_Research_Facility',
    SecurityOfficer: 'Security_Officer',
    SkillPlanManager: 'Skill_Plan_Manager',
    StarbaseDefenseOperator: 'Starbase_Defense_Operator',
    StarbaseFuelTechnician: 'Starbase_Fuel_Technician',
    StationManager: 'Station_Manager',
    Trader: 'Trader'
} as const;
export type GetCorporationsCorporationIdRolesHistory200OkNewRolesEnum = typeof GetCorporationsCorporationIdRolesHistory200OkNewRolesEnum[keyof typeof GetCorporationsCorporationIdRolesHistory200OkNewRolesEnum];

/**
 * @export
 */
export const GetCorporationsCorporationIdRolesHistory200OkOldRolesEnum = {
    AccountTake1: 'Account_Take_1',
    AccountTake2: 'Account_Take_2',
    AccountTake3: 'Account_Take_3',
    AccountTake4: 'Account_Take_4',
    AccountTake5: 'Account_Take_5',
    AccountTake6: 'Account_Take_6',
    AccountTake7: 'Account_Take_7',
    Accountant: 'Accountant',
    Auditor: 'Auditor',
    BrandManager: 'Brand_Manager',
    CommunicationsOfficer: 'Communications_Officer',
    ConfigEquipment: 'Config_Equipment',
    ConfigStarbaseEquipment: 'Config_Starbase_Equipment',
    ContainerTake1: 'Container_Take_1',
    ContainerTake2: 'Container_Take_2',
    ContainerTake3: 'Container_Take_3',
    ContainerTake4: 'Container_Take_4',
    ContainerTake5: 'Container_Take_5',
    ContainerTake6: 'Container_Take_6',
    ContainerTake7: 'Container_Take_7',
    ContractManager: 'Contract_Manager',
    DeliveriesContainerTake: 'Deliveries_Container_Take',
    DeliveriesQuery: 'Deliveries_Query',
    DeliveriesTake: 'Deliveries_Take',
    Diplomat: 'Diplomat',
    Director: 'Director',
    FactoryManager: 'Factory_Manager',
    FittingManager: 'Fitting_Manager',
    HangarQuery1: 'Hangar_Query_1',
    HangarQuery2: 'Hangar_Query_2',
    HangarQuery3: 'Hangar_Query_3',
    HangarQuery4: 'Hangar_Query_4',
    HangarQuery5: 'Hangar_Query_5',
    HangarQuery6: 'Hangar_Query_6',
    HangarQuery7: 'Hangar_Query_7',
    HangarTake1: 'Hangar_Take_1',
    HangarTake2: 'Hangar_Take_2',
    HangarTake3: 'Hangar_Take_3',
    HangarTake4: 'Hangar_Take_4',
    HangarTake5: 'Hangar_Take_5',
    HangarTake6: 'Hangar_Take_6',
    HangarTake7: 'Hangar_Take_7',
    JuniorAccountant: 'Junior_Accountant',
    PersonnelManager: 'Personnel_Manager',
    ProjectManager: 'Project_Manager',
    RentFactoryFacility: 'Rent_Factory_Facility',
    RentOffice: 'Rent_Office',
    RentResearchFacility: 'Rent_Research_Facility',
    SecurityOfficer: 'Security_Officer',
    SkillPlanManager: 'Skill_Plan_Manager',
    StarbaseDefenseOperator: 'Starbase_Defense_Operator',
    StarbaseFuelTechnician: 'Starbase_Fuel_Technician',
    StationManager: 'Station_Manager',
    Trader: 'Trader'
} as const;
export type GetCorporationsCorporationIdRolesHistory200OkOldRolesEnum = typeof GetCorporationsCorporationIdRolesHistory200OkOldRolesEnum[keyof typeof GetCorporationsCorporationIdRolesHistory200OkOldRolesEnum];

/**
 * @export
 */
export const GetCorporationsCorporationIdRolesHistory200OkRoleTypeEnum = {
    GrantableRoles: 'grantable_roles',
    GrantableRolesAtBase: 'grantable_roles_at_base',
    GrantableRolesAtHq: 'grantable_roles_at_hq',
    GrantableRolesAtOther: 'grantable_roles_at_other',
    Roles: 'roles',
    RolesAtBase: 'roles_at_base',
    RolesAtHq: 'roles_at_hq',
    RolesAtOther: 'roles_at_other'
} as const;
export type GetCorporationsCorporationIdRolesHistory200OkRoleTypeEnum = typeof GetCorporationsCorporationIdRolesHistory200OkRoleTypeEnum[keyof typeof GetCorporationsCorporationIdRolesHistory200OkRoleTypeEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdRolesHistory200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdRolesHistory200Ok(value: object): value is GetCorporationsCorporationIdRolesHistory200Ok {
    if (!('changedAt' in value) || value['changedAt'] === undefined) return false;
    if (!('characterId' in value) || value['characterId'] === undefined) return false;
    if (!('issuerId' in value) || value['issuerId'] === undefined) return false;
    if (!('newRoles' in value) || value['newRoles'] === undefined) return false;
    if (!('oldRoles' in value) || value['oldRoles'] === undefined) return false;
    if (!('roleType' in value) || value['roleType'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdRolesHistory200OkFromJSON(json: any): GetCorporationsCorporationIdRolesHistory200Ok {
    return GetCorporationsCorporationIdRolesHistory200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdRolesHistory200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdRolesHistory200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'changedAt': (new Date(json['changed_at'])),
        'characterId': json['character_id'],
        'issuerId': json['issuer_id'],
        'newRoles': json['new_roles'],
        'oldRoles': json['old_roles'],
        'roleType': json['role_type'],
    };
}

export function GetCorporationsCorporationIdRolesHistory200OkToJSON(json: any): GetCorporationsCorporationIdRolesHistory200Ok {
    return GetCorporationsCorporationIdRolesHistory200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdRolesHistory200OkToJSONTyped(value?: GetCorporationsCorporationIdRolesHistory200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changed_at': ((value['changedAt']).toISOString()),
        'character_id': value['characterId'],
        'issuer_id': value['issuerId'],
        'new_roles': value['newRoles'],
        'old_roles': value['oldRoles'],
        'role_type': value['roleType'],
    };
}

